import moment, { MomentInput } from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';

export const formatDate = (date: MomentInput, format?: string): MomentInput =>
  moment(date).format(format ?? DEFAULT_DATE_FORMAT);

export const getDueDateForGantt = (dueDate: MomentInput): MomentInput =>
  formatDate(moment(dueDate).add(1, 'day'));

type GanttDueDateEntity = { endDate: Date | string | number };

export const getDueDateFromGantt = (
  entity: GanttDueDateEntity,
  format?: string,
): MomentInput => formatDate(moment(entity.endDate).subtract(1, 'day'), format);
